export default __webpack_public_path__ + "media/552d686f8c4b83bca1da54bab034a66c9964682b9e1023eb056932f4870b207c.svg";